import script from "./ITeams.vue?vue&type=script&setup=true&lang=js"
export * from "./ITeams.vue?vue&type=script&setup=true&lang=js"

import "./ITeams.vue?vue&type=style&index=0&id=2dc4064f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc4064f"]])

export default __exports__